export default __webpack_public_path__ + "static/media/ISMO CLASS-1_SYLLABUS_2025-26.43a7b790.pdf";